import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PolicyXML } from 'src/app/models/common';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';

@Component({
  selector: 'app-version-details',
  templateUrl: './version-details.component.html',
  styleUrls: ['./version-details.component.scss']
})
export class VersionDetailsComponent implements OnInit {
  @Input() public Content: any;
  policy: PolicyXML;
  States: any = [];
  Screens: any = [];
  constructor(public modalRef: NgbActiveModal, public summaryService: UmSummaryService) {

  }
  ngOnInit(): void {
    this.getVersionDetail();
  }
  getVersionDetail() {
    this.States = [];
    this.Screens = [];
    this.summaryService.getVersionDetails(this.Content.VersionID, this.Content.screencode, this.Content.Policy_ID).subscribe(summary => {
      this.policy = summary.Data;
      this.policy.States.forEach((state, index) => {
        if (state.ISCHECKED && state.STATUSCODE != '9') {
          this.States.push(state.OLDNAME);
        }
        if (index == 0) {
          state.Features.forEach((screen) => {
            if (screen.ISCHECKED) {
              this.Screens.push(screen.OldName);
            }

          });
        }

      });
    });
  }

}
